import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "..";
import { Navigate } from "react-router-dom";

const initialState = {
  statistics: null,
  taskStatistics: null,
  stagesStatistics: null,
  projectsStatistics: null,
  projectsProgressStatistics: null,
  projectPhasesStatistics: null,
  lastLoggedUsers: null,
};

export const getLastLoggedUsers = createAsyncThunk(
  "dashboard/lastLoggedUsers",
  async (params) => {
    return await axiosInstance
      .get("Auth/recent-logins", {
        params,
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return <Navigate to={"/login"} />;
        // return err;
      });
  },
);
export const getStatistics = createAsyncThunk(
  "dashboard/statistics",
  async (params) => {
    return await axiosInstance
      .get("Dashboard/SalaryGrade/Statistics", {
        params,
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return <Navigate to={"/login"} />;
        // return err;
      });
  },
);

export const getTaskStatistics = createAsyncThunk(
  "dashboard/MyTasks",
  async (params) => {
    return await axiosInstance
      .get("Dashboard/Tasks/Statistics", {
        params,
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return <Navigate to={"/login"} />;
        // return err;
      });
  },
);
export const getStagesStatistics = createAsyncThunk(
  "dashboard/stages",
  async (params) => {
    return await axiosInstance
      .get("Dashboard/Stage/Statistics", {
        params,
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
  },
);
export const getProjectsStatistics = createAsyncThunk(
  "dashboard/users",
  async (params) => {
    return await axiosInstance
      .get("Dashboard/User/Statistics", {
        params,
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
  },
);

export const getProjectPhasesStatistics = createAsyncThunk(
  "dashboard/projectPhases",
  async (params) => {
    return await axiosInstance
      .get(
        params.projectId
          ? `projects/Phase/Progress/${params.projectId}`
          : "projects/Progress",
        {
          params: { ProjectStatus: params.ProjectStatus },
        },
      )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
  },
);

const DashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getLastLoggedUsers.fulfilled, (state, action) => {
      state.lastLoggedUsers = action.payload.data?.data;
    });
    builder.addCase(getLastLoggedUsers.rejected, (state, action) => {
      state.lastLoggedUsers = null;
    });
    builder.addCase(getStatistics.fulfilled, (state, action) => {
      state.statistics = action.payload.data?.data;
    });
    builder.addCase(getStatistics.rejected, (state, action) => {
      state.statistics = null;
    });
    builder.addCase(getTaskStatistics.fulfilled, (state, action) => {
      state.taskStatistics = action.payload.data;
    });

    builder.addCase(getStagesStatistics.fulfilled, (state, action) => {
      state.stagesStatistics = action.payload.data?.stagesTotals;
    });
    builder.addCase(getProjectsStatistics.fulfilled, (state, action) => {
      state.projectsStatistics = action.payload.data;
    });
    builder.addCase(getProjectPhasesStatistics.fulfilled, (state, action) => {
      state.projectPhasesStatistics = action.payload.data;
    });
  },
});

export const DashboardReducer = DashboardSlice.reducer;
